import Dexie, { type EntityTable } from 'dexie'
import type { AppSetting, CaptureProfile, RankQueueItem, SessionRecord } from '@/domain/types'

class MapleLogDatabase extends Dexie {
  profiles!: EntityTable<CaptureProfile, 'id'>
  sessions!: EntityTable<SessionRecord, 'id'>
  settings!: EntityTable<AppSetting, 'key'>
  rankQueue!: EntityTable<RankQueueItem, 'id'>

  constructor() {
    super('maple-log')
    this.version(1).stores({
      profiles: 'id, [presetId+presetVersion], updatedAt',
      sessions: 'id, presetId, status, startedAt, endedAt',
      observations: '++id, sessionId, [sessionId+capturedAt], capturedAt',
      events: 'id, sessionId, [sessionId+capturedAt], type, capturedAt',
      settings: 'key, updatedAt',
    })
    this.version(2).stores({
      profiles: 'id, [presetId+presetVersion], updatedAt',
      sessions: 'id, presetId, status, startedAt, endedAt',
      observations: null,
      events: null,
      settings: 'key, updatedAt',
    })
    this.version(3).stores({
      profiles: 'id, [presetId+presetVersion], updatedAt',
      sessions: 'id, presetId, status, startedAt, endedAt',
      settings: 'key, updatedAt',
    }).upgrade((transaction) => transaction.table('sessions').clear())
    this.version(4).stores({
      profiles: 'id, [presetId+presetVersion], updatedAt',
      sessions: 'id, presetId, status, startedAt, endedAt',
      settings: 'key, updatedAt',
      rankQueue: 'id, nextAttemptAt, createdAt',
    })
  }
}

export const db = new MapleLogDatabase()

export class RecoveryBuffer {
  private lastFlushAt = 0

  async flush(session: SessionRecord, force = false): Promise<void> {
    const now = Date.now()
    if (!force && now - this.lastFlushAt < 5_000) return
    const previousFlushAt = this.lastFlushAt
    this.lastFlushAt = now
    try {
      await db.sessions.put(session)
    } catch (error) {
      this.lastFlushAt = previousFlushAt
      throw error
    }
  }
}
